import { NotifyTypeIncludesEnum } from 'src/app/shared/enum/notify-type-includes.enum';

export const notificationNavigateDetails = {
  [NotifyTypeIncludesEnum.ACTION_PLAN_APPROVAL]: {
    url: 'action-plan/details',
    idKey: 'action_plan_approval_id',
    queryParamsKey: ['approval_id'],
  },
  [NotifyTypeIncludesEnum.SECOND_ROUND_SUPPORT]: {
    url: 'second-round-asset-support/details',
    idKey: 'second_round_asset_support_approval_id',
    queryParamsKey: ['approval_id'],
  },
  [NotifyTypeIncludesEnum.ADHOC_APPROVAL]: {
    url: 'general-purchase/details',
    idKey: 'adhoc_approval_id',
    queryParamsKey: ['approval_id'],
  },
};
